module.exports = __webpack_public_path__ + "media/images/icons/twitter-e3281a3c5b3dfe3511217229f473ed22.svg";